var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-actions"},[_c('b-button',{staticClass:"w-100",attrs:{"variant":"primary","onclick":"self.close()"}},[_c('span',{domProps:{"textContent":_vm._s(_vm.$t('general.button.close'))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }